var r="4.4.2";export{r as version};
//# sourceMappingURL=package.json.js.map
